/* eslint react-hooks/exhaustive-deps: "warn" */

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './SectionSince2015.module.scss';

export const SectionSince2015 = () => (
  <Section background="#DCE2F5" className={styles.root}>
    <div className={styles.inner}>
      <div className={styles.rail}>
        <span className={styles.eyebrow}>02</span>
        <p className={styles.railTitle}>Since 2015</p>
      </div>

      <div className={styles.content}>
        <TitleBlock
          title={<>Built the hard&nbsp;way.</>}
          description="Company registries were never designed to work together. We connected them source by source, standardising different formats, languages and filing systems into one global data model. That foundation took a decade to build, and it cannot be replicated overnight."
          align="left"
        />
      </div>
    </div>
  </Section>
);
